import { FC } from 'react';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { Title } from '@/shared/uikit/Title';

type ModalTitle = {
  title: string;
};

export const ModalTitle: FC<ModalTitle> = ({ title }) => (
  <Container>
    <Title size={16} bold>
      {title}
    </Title>
  </Container>
);

const Container = styled.div`
  padding: 16px 24px;

  ${media.sm} {
    padding: 16px;
    padding-bottom: 24px;
  }
`;
